module.exports={
  "name": "aframe",
  "version": "0.2.0-rc1",
  "description": "Building blocks for the VR Web",
  "main": "dist/aframe.js",
  "scripts": {
    "browserify": "browserify src/index.js -s 'AFRAME' -p browserify-derequire",
    "build": "mkdirp build/ && npm run browserify -- --debug -o build/aframe.js",
    "dev": "npm run build && node ./scripts/budo",
    "dist": "mkdirp dist/ && npm run browserify -s -- --debug | exorcist dist/aframe.js.map > dist/aframe.js && uglifyjs dist/aframe.js -c warnings=false -m -o dist/aframe.min.js",
    "gh-pages": "npm run ghpages",
    "ghpages": "node ./scripts/gh-pages",
    "lint": "semistandard -v | snazzy",
    "precommit": "npm run lint",
    "preghpages": "npm run dist && rimraf gh-pages && mkdirp gh-pages && cp -r {.nojekyll,dist,lib,examples,index.html,style} gh-pages/. 2>/dev/null || : && git checkout dist/ && replace 'build/aframe.js' 'dist/aframe.min.js' gh-pages/ -r --silent",
    "release:bump": "npm run dist && git commit -am 'bump dist' && npm version patch --preminor",
    "release:push": "npm login && npm publish && git push --follow-tags",
    "start": "npm run dev",
    "test": "karma start ./tests/karma.conf.js",
    "test:ci": "TEST_ENV=ci karma start ./tests/karma.conf.js --single-run",
    "version": "npm run dist"
  },
  "repository": "aframevr/aframe",
  "license": "MIT",
  "dependencies": {
    "browserify-css": "^0.8.2",
    "debug": "^2.2.0",
    "deep-assign": "^2.0.0",
    "document-register-element": "dmarcos/document-register-element#8ccc532b7",
    "promise-polyfill": "^3.1.0",
    "object-assign": "^4.0.1",
    "polymerize": "^1.0.0",
    "present": "0.0.6",
    "request-interval": "^1.0.0",
    "style-attr": "^1.0.2",
    "three": "^0.74.0",
    "tween.js": "^15.0.0",
    "webvr-polyfill": "borismus/webvr-polyfill#3f47796"
  },
  "devDependencies": {
    "browserify": "^11.0.1",
    "browserify-derequire": "^0.9.4",
    "budo": "^8.1.0",
    "chai": "^3.5.0",
    "chai-shallow-deep-equal": "^1.3.0",
    "exorcist": "^0.4.0",
    "gh-pages": "^0.6.0",
    "husky": "^0.10.1",
    "karma": "^0.13.15",
    "karma-browserify": "^4.4.0",
    "karma-chai-shallow-deep-equal": "0.0.4",
    "karma-env-preprocessor": "^0.1.1",
    "karma-firefox-launcher": "^0.1.6",
    "karma-mocha": "^0.2.0",
    "karma-mocha-reporter": "^1.1.0",
    "karma-sinon-chai": "^1.1.0",
    "lolex": "^1.4.0",
    "mkdirp": "0.5.1",
    "mocha": "^2.3.3",
    "mozilla-download": "^1.0.5",
    "open": "0.0.5",
    "replace": "^0.3.0",
    "rimraf": "2.5.0",
    "semistandard": "^7.0.2",
    "sinon": "^1.17.3",
    "sinon-chai": "^2.8.0",
    "snazzy" : "^3.0.0",
    "uglifyjs": "^2.4.10"
  },
  "link": true,
  "browserify": {
    "transform": [
      "browserify-css",
      [
        "polymerize",
        {
          "match": ".*.html$"
        }
      ]
    ]
  },
  "semistandard": {
    "ignore": [
      "build/**",
      "dist/**",
      "examples/_js/**",
      "examples/**/shaders/*.js",
      "vendor/**"
    ]
  },
  "keywords": [
    "aframe",
    "vr",
    "webvr",
    "3d",
    "three",
    "components",
    "elements"
  ],
  "browserify-css": {
    "minify": true
  },
  "engines": {
    "node": ">= 0.12.7",
    "npm": "^2.12.1"
  }
}
